"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BillingInformationType = void 0;
var BillingInformationType;
(function (BillingInformationType) {
    BillingInformationType[BillingInformationType["Natural"] = 0] = "Natural";
    BillingInformationType[BillingInformationType["Legal"] = 1] = "Legal";
    BillingInformationType[BillingInformationType["Soletrader"] = 2] = "Soletrader";
})(BillingInformationType || (exports.BillingInformationType = BillingInformationType = {}));
//# sourceMappingURL=BillingInformationType.js.map